import { UIHeading4 } from '@cian/ui-kit';

import { forwardRef } from 'react';

import { Link, WrapElementsSpacer } from '@/packages/shared-ui';

import styles from './SEOBottomLinksBlock.css';

type SeoLink = {
  id: number;
  title: string;
  url: string;
};

type SEOBottomLinksBlockProps = {
  title: string;
  links: SeoLink[];
  trackLinkClick(): void;
};

export const SEOBottomLinksBlock = forwardRef<HTMLDivElement, SEOBottomLinksBlockProps>(
  function SEOBottomLinksBlock(props, ref) {
    const { links, title, trackLinkClick } = props;

    return (
      <div className={styles['container']} ref={ref}>
        <UIHeading4 as="h4">{title}</UIHeading4>
        <WrapElementsSpacer horizontalSpace={16} verticalSpace={8}>
          {links.map(link => (
            <Link behaviour="hover_gray_to_primary" href={link.url} key={link.id} track={trackLinkClick}>
              {link.title}
            </Link>
          ))}
        </WrapElementsSpacer>
      </div>
    );
  },
);
